<template>
    <div class="cliente" app>
        <Navbar/>
        
        <v-content>
            <v-overlay
                absolute
                :value="loading"
                class="text-center"
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <v-dialog v-model="dialog_remove" max-width="800px" :dark="customization.dark">
                <v-card>
                    <v-card-title>Remover {{title}}</v-card-title>
                    <v-card-subtitle>Certeza que você quer remover esse registro? essa ação é irreversível!</v-card-subtitle>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog_remove = false">Cancelar</v-btn>
                        <v-btn color="red darken-1"  text @click="remover">Remover</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row align="center" justify="center" style="padding: 16px 16px; margin-top: 30px">
                <v-col cols="12" sm="11" md="10">
                    <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                        <v-alert 
                            type="error"
                            :value="alert.length > 0"
                            :dark="customization.dark">
                            {{alert}}
                        </v-alert>
                        <v-form :id="`${nameType}_form`">
                            <h1 style="padding: 16px 16px">{{`Visualização ${title}`}}</h1>
                            <v-row align="center" justify="center" style="padding: 16px 16px">
                                <v-col 
                                    v-for="col in cols"
                                    :key="col.value"
                                    :cols="col.cols"
                                    :sm="col.sm"
                                    :md="col.md"
                                    align="center"
                                >
                                    <v-text-field
                                        v-if="col.type == 'text'"
                                        :label="col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :value="selecionado[col.value]"
                                        disabled
                                    ></v-text-field>
                                    <v-select
                                        v-if="col.type == 'select'"
                                        :label="col.text"
                                        :items="Object.keys(col.items)"
                                        :value="invertObj(col.items)[selecionado[col.value]]"
                                        :name="col.value"
                                        disabled
                                    ></v-select>
                                    <v-text-field
                                        v-if="col.type == 'color'"
                                        :label="col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        @focus="colorDisplay = 'block'"
                                        @blur="colorDisplay = 'none'"
                                        :value="selecionado[col.value]"
                                        disabled
                                    ></v-text-field>
                                    <v-checkbox
                                        v-if="col.type == 'check'"
                                        :label="col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :value="selecionado[col.value]"
                                        disabled
                                    ></v-checkbox>
                                    <v-text-field 
                                        v-if="col.type == 'date'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        type="date"
                                        disabled >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'time'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        type="time"
                                        disabled >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'password'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        type="password"
                                        disabled >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'number'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.text"
                                        :name="col.value"
                                        :value="selecionado[col.value]"
                                        type="number"
                                        disabled >
                                    </v-text-field>
                                    <Autocomplete
                                        v-if="col.type == 'autocomplete'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.text"
                                        :name="col.value"
                                        :dark="customization.dark"
                                        :needWhere="col.autocomplete.needWhere"
                                        :url="col.autocomplete.url"
                                        :iddisplay="col.autocomplete.display"
                                        :idvalue="col.autocomplete.value"
                                        :value="selecionado[col.value]"
                                        :notOutline="true"
                                        disabled >
                                    </Autocomplete>
                                    <Grid
                                        v-if="col.type == 'grid'"
                                        :customization="customization" 
                                        :headers="col.grid.headers"
                                        :editable="false"
                                        :label="col.text"
                                        :name="col.value"
                                        :url="col.grid.url"
                                        :id_rel="col.grid.id_rel"
                                        :id="id">
                                    </Grid>
                                    <v-textarea
                                        v-if="col.type == 'textarea'"
                                        :label="col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :value="selecionado[col.value]"
                                        disabled
                                    ></v-textarea>
                                    <File
                                        v-if="col.type == 'fileIcon'"
                                        :label="col.text"
                                        :name="col.value"
                                        :dark="customization.dark"
                                        :mainColor="customization.mainBtnColor"
                                        :value="selecionado[col.value]"
                                        :readOnly="true"
                                    ></File>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color="green"
                    style="bottom: 15px"
                    v-on="on"
                    @click="novo"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Inserir</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='blue'
                    style="bottom: 85px"
                    v-on="on"
                    @click="editar"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
                <span>Editar</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color="red"
                    style="bottom: 155px"
                    v-on="on"
                    @click="deletar"
                    >
                        <v-icon>mdi-trash-can</v-icon>
                    </v-btn>
                </template>
                <span>Excluir</span>
            </v-tooltip>
        </v-content>
    </div>
</template>

<style scoped>

</style>

<script>
import Autocomplete     from '@/components/Autocomplete.vue';
import Grid             from '@/components/Grid.vue';
import Navbar           from '@/components/Navbar.vue';
import File             from '@/components/File.vue';
import api              from '@/plugins/apisauceHeader.js';
import router           from '@/router/index.js';
import CRUD             from '@/assets/CRUD.json';

export default {
    name: 'Create',
    components:{
        Navbar,
        Autocomplete,
        Grid,
        File
    },
    data(){
        return{
            id: null,
            selecionado: {},
            alert: "",
            requireRule:[
                r => (r && r.toString().length > 0 ) || "Essa campo é obrigatório!"
            ],
            loading: false,
            dialog_remove: false,
            customization: {},
            nameType: "",
            cols: [],
            colorDisplay: "none",
            title: ""
        }
    },
    methods:{
        invertObj(obj){
            const result = {};
            Object.keys(obj).forEach(o=>{
                result[obj[o]] = o;
            });
            return result;
        },
        novo(){
            router.push(`/Create/${this.nameType}`);
        },
        editar(){
            router.push(`/Edit/${this.nameType}/${this.id}`);
        },
        deletar(){
            let can = true;
            if(!["veiculo","equipes","estruturas"].includes(this.nameType)){
                this.cols.forEach(c=>{
                    if(c.type == "grid"){
                        const json = JSON.parse(document.getElementsByName(c.value)[0].value);
                        if(json.length > 0){
                            this.alert = "Você não pode deletar esse registro, pois tem outro registro que depende dele.";
                            can = false;
                        }
                    }
                })
            }
            
            if(can) this.dialog_remove = true;
        },
        remover(){
            this.loading = true;
            if(this.nameType == "veiculo")
                api(localStorage.getItem("token")).put(`endpoint${this.endpoint}/${this.id}`,
                {
                    deletado: "Não"
                }).then(r=>{
                    if(r.ok)
                        router.push(`/CRUD/${this.nameType}`);
                    else 
                        this.alert = r.data.mensagem;
                    this.loading = false;
                })
            else
                api(localStorage.getItem("token")).delete(`endpoint${this.endpoint}/${this.id}`).then(r=>{
                    if(r.ok)
                        router.push(`/CRUD/${this.nameType}`);
                    else 
                        this.alert = r.data.mensagem;
                    this.loading = false;
                })
        },
        get(){
            this.loading = true;
            api(localStorage.getItem("token")).get(`one/endpoint${this.endpoint}/${this.id}`).then(r=>{
                if(r.ok)
                    this.selecionado = r.data[0];
                this.loading = false;
            })
        }
    },
    mounted(){
        this.customization = JSON.parse(localStorage.getItem("customization"));
        this.nameType   = this.$route.params.nameType;
        this.id         = this.$route.params.id;
        this.endpoint = `${CRUD[this.nameType].endpoint}`;
        if(!CRUD[this.nameType]) router.push('/dashboard');

        this.title = `${CRUD[this.nameType].label ? CRUD[this.nameType].label : this.nameType}`;
        document.title = `${this.customization.name} - Visualização ${this.nameType}`;
        if(!localStorage.getItem("usrId")) router.push('/');
        this.cols = CRUD[this.nameType].cols;

        this.get();
    }
}
</script>